import React from 'react';
import { connect } from 'react-redux';
require('../../../styles/supaDropdown/supaDropdown.scss');
import { Link } from 'react-router-dom';
import { Dropdown, Icon, Menu } from 'semantic-ui-react';

@connect()
export default class SupaDropDown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showOptions: false,
      open: false,
      openSubMenu1: false,
      openSubMenu2: false,
      openSubMenu3: false,
      openSubMenu4: false,
      subMenuOptionClick: false,
    };
  }

  static renderDropdownYouCanSearchOn(text, items, placeholder, movingPlaceholder, input) {}

  static renderDropdownWithIcon(text, items, placeholder, movingPlaceholder, input) {}

  getInfoClasses = () => {
    return this.state.showOptions ? 'info active' : 'info';
  };

  renderMenuDropdownWithResponsiveness = () => {
    return (
      <div
        className={
          (this.props.amILeftAligned ? 'ui dropdown top left pointing item' : 'ui dropdown item ') +
          this.props.cssClasses
        }
      >
        {this.props.text}
        {!this.props.noIcon ? (
          <i className={this.props.amILeftAligned ? 'dropdown icon menu-icon' : 'dropdown icon'} />
        ) : (
          ''
        )}
        <div className={'menu menu-bar-dropdown' + (this.state.open ? ' visible' : '')}>
          {this.props.multiOption.split(',').map((option, i) => {
            let subOptions = option.split('@');
            if (subOptions.length > 1) {
              return (
                <div
                  className={
                    this.props.amILeftAligned ? 'menu-items-left-aligned ui item dropdown' : 'ui item dropdown'
                  }
                  key={i}
                >
                  <span className="text">{subOptions[0]}</span>
                  {!this.props.noIcon ? (
                    <i
                      className={
                        this.props.amILeftAligned ? 'dropdown icon mrlnull sub-menu-icon' : 'dropdown icon mrlnull'
                      }
                    />
                  ) : (
                    ''
                  )}
                  <div className="menu sub-menu-items">
                    {subOptions.map((subOption, i) => {
                      if (i > 0) {
                        let text = subOption.split('+')[0];
                        let urlOrFunction = subOption.split('+')[1];
                        let func = {};
                        let url = {};
                        if (urlOrFunction.indexOf('(') > -1) {
                          func = urlOrFunction.split('(')[0];
                          return (
                            <div
                              className={this.props.amILeftAligned ? 'menu-items-left-aligned item' : 'item '}
                              onClick={this.props[func]}
                              key={i + 'subOption'}
                            >
                              {text}
                            </div>
                          );
                        } else {
                          url = urlOrFunction;
                          return (
                            <div
                              className={this.props.amILeftAligned ? 'menu-items-left-aligned item' : 'item '}
                              onClick={window.open.bind(this, url, '_self')}
                              key={i + 'subOption'}
                            >
                              {text}
                            </div>
                          );
                        }
                      }
                    })}
                  </div>
                </div>
              );
            } else {
              let text = option.split('+')[0];
              let urlOrFunction = option.split('+')[1];
              let func = {};
              let url = {};
              let currentPage = '';
              if (text.indexOf('$CURRENTPAGE') > -1) {
                currentPage = true;
                text = text.split('$')[0];
              }
              if (urlOrFunction.indexOf('(') > -1) {
                func = urlOrFunction.split('(')[0];
                return (
                  <div
                    className={this.props.amILeftAligned ? 'menu-items-left-aligned item' : 'item'}
                    onClick={this.props[func]}
                    key={i}
                  >
                    {currentPage ? text + this.props.currentPageTitle : text}
                  </div>
                );
              } else {
                url = urlOrFunction;
                return (
                  <div
                    className={this.props.amILeftAligned ? 'menu-items-left-aligned item' : 'item'}
                    onClick={window.open.bind(this, url, '_self')}
                    key={i}
                  >
                    {currentPage ? text + this.props.currentPageTitle : text}
                  </div>
                );
              }
            }
          })}
        </div>
      </div>
    );
  };

  renderSemanticUiDropdown(
    text,
    options,
    {
      icon,
      className,
      trigger,
      id,
      MenuClassName,
      onChange,
      normal,
      placeholder,
      defaultValue,
      selectedValue,
      extraParam,
      noSearch,
      disabled,
    },
    selectedPlaceHolder
  ) {
    //className is being applied at dropdown tag
    //MenuClassName is being applied at the dropdown menu options tag
    let ddl = '';
    let that = this;
    if (normal) {
      ddl = (
        <div>
          {' '}
          <Dropdown
            placeholder={placeholder}
            onChange={(e, v) => {
              onChange(e, v, extraParam);
            }}
            className={className}
            fluid
            search={!noSearch}
            selection
            value={selectedValue}
            disabled={disabled}
            defaultValue={defaultValue}
            options={options}
            closeOnChange={true}
          />
          {selectedPlaceHolder}
        </div>
      );
      return ddl;
    }
    if (icon == '' || icon == undefined) {
      //if icon is not provided. setting icon empty or as undefined throws a waring
      // Fix wierd dropdown behaviour in modal
      if (this.props.normalSemanticUI) {
        ddl = (
          <Dropdown
            text={text}
            id={id}
            trigger={trigger}
            onClose={() => {
              this.setState({
                openSubMenu1: false,
                openSubMenu2: false,
                openSubMenu3: false,
                openSubMenu4: false,
                open: false,
              });
            }}
            open={that.isSubMenuClick() ? that.isSubMenuClick() : this.state.open}
            className={className}
            onClick={(env) => {
              /*if any submenu is open, keep the dropdown open */
              if (this.props.onClick) {
                let returnValue = this.props.onClick(env);
                if (returnValue == false) {
                  //this is the case if we dont want to do anything ahead;
                  return;
                }
              }
              that.setState({
                open: that.isSubMenuClick() ? that.isSubMenuClick() : !that.state.open,
                id: className,
              });
            }}
          >
            <Dropdown.Menu style={this.props.menuStyle || {}} className={MenuClassName || ''}>
              {options}
            </Dropdown.Menu>
          </Dropdown>
        );
      } else {
        ddl = (
          <Dropdown
            onBlur={() => {
              setTimeout(() => {
                that.setState({
                  open: false,
                });
              }, 200);
            }}
            closeOnBlur={!!this.props.closeOnBlur}
            closeOnChange={!!this.props.closeOnChange}
            text={text}
            id={id}
            trigger={trigger}
            open={that.isSubMenuClick() ? that.isSubMenuClick() : this.state.open}
            onChange={this.props.onChange}
            className={className}
            onClick={(env) => {
              /*if any submenu is open, keep the dropdown open */
              if (this.props.onClick) {
                let returnValue = this.props.onClick(env);
                if (returnValue == false) {
                  //this is the case if we dont want to do anything ahead;
                  return;
                }
              }
              that.setState({
                open: that.isSubMenuClick() ? that.isSubMenuClick() : !that.state.open,
                id: className,
              });
            }}
          >
            <Dropdown.Menu style={this.props.menuStyle || {}} className={MenuClassName || ''}>
              {options}
            </Dropdown.Menu>
          </Dropdown>
        );
      }
    } else {
      ddl = (
        <Dropdown
          text={text}
          trigger={trigger}
          id={id}
          open={(that.isSubMenuClick() ? that.isSubMenuClick() : this.state.open) || !!this.props.open}
          icon={icon}
          className={className}
          onClick={() => {
            if (this.props.onClick == undefined) {
              that.setState({
                open: that.isSubMenuClick() ? that.isSubMenuClick() : !that.state.open,
                id: className,
              });
            } else {
              this.props.onClick();
            }
          }}
        >
          <Dropdown.Menu className={MenuClassName || ''}>{options}</Dropdown.Menu>
        </Dropdown>
      );
    }

    return ddl;
  }
  calculateNormalOptions(props) {
    const options = props.options || [];

    let finalOptions = [];
    options.map((x, i) => {
      const text = x[props.text] || x.text;
      const value = x[props.value] || x.value;
      const key = value || text;
      finalOptions.push({ text, value, key });
    });

    return finalOptions;
  }
  calculateSemanticUIDropDownOptions(multiOptions) {
    let dropdownOption = [];
    let rowLength = multiOptions.length,
      subMenuOption = 0;
    multiOptions.map((options, index) => {
      let innerOptionExist = false;
      if (Array.isArray(options)) {
        //means this is a nested array
        options.map((option, i) => {
          if (option['data-show'] || option['data-show'] == undefined) {
            innerOptionExist = true;
            //if dropdown option is to be displayed then only we set the inneroption exist flag true

            dropdownOption.push(
              <Dropdown.Item key={option.id || option.Id || option.value || option.text} {...option} />
            );
          }
        });
      } else {
        //facilitated dev, if they don't want to pass nested array object they can pass a single array as well
        if (options.show != false) {
          let subMenus = []; //submenus Array
          if (options.subMenuOption && options.subMenuOption.length > 0) {
            //this if condition only works if we have any submenu
            options.subMenuOption.map((subMenu, i) => {
              subMenus.push(
                <Dropdown.Item
                  key={subMenu.value ? subMenu.value : subMenu.text}
                  {...subMenu}
                  onClick={(ev) => {
                    this.setOpenSubMenu(ev, '');
                    subMenu.onClick();
                  }}
                />
              );
            });
            subMenuOption++;
            let openSubMenu = 'openSubMenu' + subMenuOption; //setting the submenu id --- as we supporting submenu1 submenu2 and submenu3 only
            dropdownOption.push(
              <Dropdown.Item
                className={options.className}
                key={index + 10}
                onClick={(ev) => {
                  this.setOpenSubMenu(ev, openSubMenu);
                }}
              >
                <Icon name="dropdown" />
                <span className="text">{options.text}</span>
                <Dropdown.Menu
                  className={this.state[openSubMenu] ? options.subMenuClass : options.subMenuClass + ' hidden'}
                >
                  {subMenus}
                </Dropdown.Menu>
              </Dropdown.Item>
            );
          } else {
            if (options.link) {
              dropdownOption.push(
                <Dropdown.Item
                  key={options.value ? options.value : options.text}
                  {...options}
                  as={Link}
                  to={options.link}
                  className={options.className ? options.className : 'item'}
                />
              );
              // dropdownOption.push(
              //   <Menu.Item
              //     key={options.value ? options.value : options.text}
              //     {...options}
              //     className={options.className ? options.className : 'item'}
              //     as={Link}
              //     to={options.link}
              //   >{options.text}</Menu.Item>
              // );
            } else {
              dropdownOption.push(
                <Dropdown.Item
                  key={options.value ? options.value : options.text}
                  {...options}
                  onClick={(ev) => {
                    this.setOpenSubMenu(ev, '');
                    this.props.childOnClickfuc ? this.props.childOnClickfuc() : '';
                    options.onClick ? options.onClick() : '';
                  }}
                  className={options.className ? options.className : 'item'}
                />
              );
            }
          }
        }
      }

      if (rowLength > index + 1 && innerOptionExist) {
        //we do not want to show the divider for the last option
        //we also do not want to show the divider if all the options are hidden :)
        dropdownOption.push(<Dropdown.Divider key={'dropDownDivider' + index} />);
      }
    });

    if (dropdownOption.length > 0 && dropdownOption[dropdownOption.length - 1].key.indexOf('dropDownDivider') >= 0) {
      //if the last option is divider, just popup it out
      dropdownOption.pop();
    }
    return dropdownOption;
  }
  setOpenSubMenu(ev, subMenuName) {
    //if submenuname is being sent empty it means, close everything
    if (subMenuName == '') {
      this.setState({
        openSubMenu1: false,
        openSubMenu2: false,
        openSubMenu3: false,
        openSubMenu4: false,
        open: false,
      });
    } else {
      //toggle the state of that particular submenu
      this.setState({
        openSubMenu1: 'openSubMenu1' == subMenuName ? !this.state.openSubMenu1 : false,
        openSubMenu2: 'openSubMenu2' == subMenuName ? !this.state.openSubMenu2 : false,
        openSubMenu3: 'openSubMenu3' == subMenuName ? !this.state.openSubMenu3 : false,
        openSubMenu4: 'openSubMenu4' == subMenuName ? !this.state.openSubMenu4 : false,
      });
    }
    ev.stopPropagation(); //we stop the propogation as it calls the parent click event also
  }
  isSubMenuClick() {
    //returns if any of the submenu is open
    if (this.state.openSubMenu1 || this.state.openSubMenu2 || this.state.openSubMenu3 || this.state.openSubMenu4)
      return true;
    return false;
  }
  renderNormalDropdown = (text, items, placeholder, movingPlaceholder, input) => {
    return (
      <div className="field supa-dropdown-parent">
        <div className={this.getInfoClasses()}>
          <span
            ref={(input) => {
              this.InfoElement = input;
            }}
          >
            {text}
          </span>
        </div>
        <div className=" supa-dropdown" onClick={this.handleSupaDropdownClick}>
          {input}
          {placeholder}
          {this.renderCssEasingEffect()}

          <div className={this.getInfoClasses()}>
            <span
              ref={(input) => {
                this.InfoElement = input;
              }}
            >
              {text}
            </span>
          </div>
          {items}
        </div>
      </div>
    );
  };

  hideWhenClickAway = (ev) => {
    try {
      if (
        (!ev.target.classList.contains('dropdown') &&
          !ev.target.parentElement.classList.contains('dropdown') &&
          !ev.target.parentElement.parentElement.classList.contains('dropdown') &&
          !ev.target.parentElement.parentElement.parentElement.classList.contains('dropdown')) ||
        ev.target.parentElement.classList.contains('user-avatar')
      ) {
        this.setState({
          open: false,
          openSubMenu1: false,
          openSubMenu2: false,
          openSubMenu3: false,
          openSubMenu4: false,
        });
      } else if (
        ev.target.classList.value &&
        !(ev.target.classList.value.indexOf(this.state.id) > -1) &&
        !(ev.target.parentElement.classList.value.indexOf(this.state.id) > -1) &&
        !(ev.target.parentElement.parentElement.classList.value.indexOf(this.state.id) > -1) &&
        !(ev.target.parentElement.parentElement.parentElement.classList.value.indexOf(this.state.id) > -1)
      ) {
        //&& !ev.target.parentElement.classList.contains(this.state.id) && !ev.target.parentElement.parentElement.classList.contains(this.state.id) && !ev.target.parentElement.parentElement.parentElement.classList.contains(this.state.id)) {

        this.setState({
          open: false,
          openSubMenu1: false,
          openSubMenu2: false,
          openSubMenu3: false,
          openSubMenu4: false,
        });
      }
    } catch (ex) {}
  };

  renderCssEasingEffect = () => {
    return <div className="clickEffect" />;
  };

  renderInputToKnowValueIsSelectedThroughCss = () => {
    return (
      <input
        ref={(input) => {
          this.HiddenInput = input;
        }}
        className={this.props.value ? 'filled' : ' '}
        type="hidden"
        name="random"
      />
    );
  };

  componentWillUnmount() {
    document.body.removeEventListener('click', this.hideWhenClickAway);
  }

  componentDidMount() {
    document.body.addEventListener('click', this.hideWhenClickAway);
  }

  handleSupaDropdownClick = () => {
    this.HiddenInput.focus();
    this.setState({
      showOptions: !this.state.showOptions,
    });
  };
  calculateOptions = (options) => {
    let finalOptions = [];
    let optionText;
    let active;
    let properties;
    for (var option of options) {
      optionText = '';
      active = false;
      if (this.props.fields != undefined) {
        //we can pass custom fields like name, age , etc so option can be an object {}
        properties = this.props.fields.split(','); //creating an array of the passed
        properties.map(function (property, i) {
          if (i == 0)
            //if first element we dont have to put brackets arround
            optionText += option[property] != undefined ? option[property] : '';
          else optionText += ' (' + (option[property] != undefined ? option[property] : '') + ')'; //if undefined we insert empty value
        });
      } else optionText = option;
      if (this.props.value != undefined && optionText == this.props.value) {
        active = true;
      }
      finalOptions.push({
        key: option.id || option.Id || option,
        value: option,
        text: optionText,
        active: active,
      });
    }
    return finalOptions;
  };
  renderItems = (options) => {
    let items = '';
    if (this.state.showOptions) {
      items = options.map((option, i) => {
        return (
          <div
            className="item"
            data-selected={this.props.value == option.text}
            key={option.key}
            onClick={this.handleChange(option.value)}
            value={option.text}
          >
            {option.text}
          </div>
        );
      });
    }
    return items;
  };

  renderMovingPlaceholder = () => {
    return (
      <span
        className={this.props.value && this.props.value != this.props.text ? 'default text color-info' : 'default text'}
      >
        {this.props.value || this.props.text}
      </span>
    );
  };

  renderPlaceholder = () => {
    return (
      <label
        className="placeholder-label no-bold"
        htmlFor={
          this.props.selectedItemPlaceholder != undefined ? this.props.selectedItemPlaceholder : this.props.placeholder
        }
      >
        {this.props.selectedItemPlaceholder != undefined ? this.props.selectedItemPlaceholder : this.props.placeholder}
      </label>
    );
  };

  handleChange = (evt) => {
    this.props.onChange(evt);
    this.setState({
      showOptions: !this.state.showOptions,
    });
    setTimeout(() => {
      let event = new Event('change', { bubbles: true });
      this.InfoElement.dispatchEvent(event); //trigger input event for validation purposes
    }, 0); //I need this to execute on a separate thread
  };

  decideTextToShow = () => {
    return this.props.value || this.props.text;
  };

  render() {
    let dropdownFinished = <div />;
    let finalOptions = '';

    if (this.props.semanticui) {
      finalOptions = this.props.options;
      if (this.props.normal) {
        dropdownFinished = this.renderSemanticUiDropdown(
          this.decideTextToShow(),
          this.calculateNormalOptions(this.props),
          this.props,
          this.renderPlaceholder()
        );
      } else {
        dropdownFinished = this.renderSemanticUiDropdown(
          this.decideTextToShow(),
          this.calculateSemanticUIDropDownOptions(finalOptions),
          this.props
        );
      }
    } else if (!this.props.menudropdown) {
      finalOptions = this.calculateOptions(this.props.options);
      dropdownFinished = this.renderNormalDropdown(
        this.decideTextToShow(),
        this.renderItems(finalOptions),
        this.renderPlaceholder(),
        this.renderMovingPlaceholder(),
        this.renderInputToKnowValueIsSelectedThroughCss()
      );
    } else {
      dropdownFinished = this.renderMenuDropdownWithResponsiveness();
    }

    return dropdownFinished;
  }
}

/*supported props :
tabIndex
onChange
text
noSearch: if this is passed as true, dropdown is not searchAble
extraParam: if you want to pass things along with selected value at OnChange event.
value
selectedItemPlaceholder //after an item has been selected, this placeholder is shown
placeholder //before an item has been selected, this placeholder is shown
classes // dropdown classes
itemClasses // classes for the items
disabled //disabled prop for normal dropdown
options // an array of the data you want to render
fields // if you passed an array of objects, this will search for fields/properties inside those objects*/
